import React from 'react'
import * as Yup from 'yup'
import { Formik } from 'formik'

import Card from '@components/Card'
import Axios from '@components/Axios'
import Button from '@components/Button'

import FormGroupAbout from './components/FormGroupAbout'

import './styles.scss'

const AddEditHowItWorks = props => {
  let { updateList, item } = props

  const schema = {
    enableReinitialize: true,
    initialValues: { ...item },
    validationSchema: Yup.object().shape({
      blockTitle: Yup.string().required('REQUIRED'),
      blockTextOne: Yup.string().required('REQUIRED'),
      blockTextTwo: Yup.string().required('REQUIRED'),
      blockTextThree: Yup.string().required('REQUIRED'),
      blockTextFour: Yup.string().required('REQUIRED')
    })
  }

  const footer = submit => {
    return <Button onClick={submit}>ABOUT_PAGE_ADD_CARD_SEND</Button>
  }

  const add = ({ handleSubmit, ...formik }) => {
    return (
      <Card footer={() => footer(handleSubmit)}>
        <FormGroupAbout {...props} formik={formik} />
      </Card>
    )
  }

  const onSubmit = ({ values, submit, resetForm }) => {
    submit({ params: values })
    resetForm()
  }

  return (
    <div className="AddEditHowItWorks">
      <Axios method="put" api="admin.aboutpage" onSuccess={updateList}>
        {({ submit }) => (
          <Formik
            {...schema}
            onSubmit={(values, event) => onSubmit({ ...event, values, submit })}
          >
            {formik => add(formik)}
          </Formik>
        )}
      </Axios>
    </div>
  )
}

export default AddEditHowItWorks
